import { FormHelperText, Grid, OutlinedInput } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

function BlockTextfield({
  id = '',
  input,
  updateField,
  errorText
}: {
  id?: string,
  input: any,
  updateField: (e: any) => void,
  errorText: string
}) {
  const refs = useRef<any>([]);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (input.maxLength && input.numberOfTextInEachBlock) {
      const numberOfBlocks = Number(input.maxLength / input.numberOfTextInEachBlock);
      const ar: any = Array(numberOfBlocks).fill('');
      setFields(ar);
    }
  }, []);

  const modifyCurrentFields = (text: any, index: any) => {
    setFields((x) => {
      const temp: any = [...x];
      temp[index] = text;
      updateField(temp.join(''));
      return temp;
    });
  };

  const first = (t: any, i: any) => {
    if (t?.length > input.numberOfTextInEachBlock) {
      modifyCurrentFields(t.charAt(t?.length - 1), i + 1);
      refs.current[i + 1].focus();
    } else {
      modifyCurrentFields(t, i);
      if (t?.length === input.numberOfTextInEachBlock) {
        refs.current[i + 1].focus();
      }
    }
  };
  const middle = (t: any, i: any) => {
    if (t?.length > input.numberOfTextInEachBlock) {
      modifyCurrentFields(t.charAt(t?.length - 1), i + 1);
      refs.current[i + 1].focus();
    } else if (t?.length === 0) {
      modifyCurrentFields(t, i);
      refs.current[i - 1].focus();
    } else {
      modifyCurrentFields(t, i);
      if (t?.length === input.numberOfTextInEachBlock) {
        refs.current[i + 1].focus();
      }
    }
  };
  const last = (t: any, i: any) => {
    if (t?.length <= input.numberOfTextInEachBlock) {
      modifyCurrentFields(t, i);
    }
    if (t?.length === 0) {
      refs.current[i - 1].focus();
    }
  };

  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      alignItems="flex-start"
      id={id}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{ width: '100%', marginBottom: '0px' }}>
        {fields?.map((fs, i) => (
          <Grid
            key={`${input.fieldName}-${i}`}
            item
            xs={12 / Number(input.maxLength / input.numberOfTextInEachBlock)}
            sm={12 / Number(input.maxLength / input.numberOfTextInEachBlock)}
            md={12 / Number(input.maxLength / input.numberOfTextInEachBlock)}
            lg={12 / Number(input.maxLength / input.numberOfTextInEachBlock)}>
            <OutlinedInput
              autoFocus={i === 0}
              sx={{ padding: 0 }}
              value={fs}
              type={'text'}
              error={errorText?.length > 0}
              inputProps={{
                style: {
                  padding: '8px 10px',
                  fontSize: '1.8rem',
                  letterSpacing: fs ? '4px' : '10px',
                  textAlign: 'center'
                },
                ref: (el: any) => (refs.current[i] = el),
                inputmode: 'numeric'
              }}
              onChange={(e: any) => {
                const t = e.target.value;
                // t = t + getDots(e.target.value)
                if (!isNaN(t)) {
                  if (i === 0) {
                    first(t, i);
                  } else if (i === input.maxLength / input.numberOfTextInEachBlock - 1) {
                    last(t, i);
                  } else {
                    middle(t, i);
                  }
                }
              }}
              onKeyDown={(e) => {
                const t = e.keyCode;
                if (t === 8 && (fs as any)?.length <= 0) {
                  if (i === 0) {
                  } else if (i === input.maxLength / input.numberOfTextInEachBlock - 1) {
                    refs.current[i - 1].focus();
                  } else {
                    refs.current[i - 1].focus();
                  }
                }
              }}
            />
          </Grid>
        ))}
      </Grid>
      {errorText?.length > 0 ? (
        <FormHelperText error={errorText?.length > 0} sx={{ textAlign: 'left', marginTop: 0 }}>
          {errorText}
        </FormHelperText>
      ) : null}
    </Grid>
  );
}

export default BlockTextfield;
